export default __webpack_public_path__ + "static/media/furniture-998265_640.a3f83d6c.jpg";